const invertedMessages = {
  'Are you sure you want to deactivate {providerName}?':
    'Auth.Prompt.ConfirmDeactivateSSOProvider',
  'Are you sure you want to activate {providerName}? It will be used for login.':
    'Auth.Prompt.ConfirmActivateSSOProvider',
  'Are you sure you want to delete {providerName}?':
    'Auth.Prompt.ConfirmDeleteSSOProvider',
  'Are you sure you want to delete this client?':
    'Auth.Prompt.ConfirmDeleteClient',
  'Are you sure you want to delete {clientName}?':
    'Auth.Prompt.ConfirmDeleteClientByName',
  'Type "{captcha}" to verify': 'Auth.Prompt.DangerousAcitivtyConfirm',
  'Removing this key will terminate any current logins signed by this key. Are you sure you want to remove this key?':
    'Auth.Prompt.ConfirmKeyRemoval',
};

export default invertedMessages;
